<template>
  <Modal v-bind="$attrs" @cancel="emits('cancel')" @confirm="onConfirm">
    <el-table border class="common-el-table-styles summary-el-table-styles" :height="222" :data="targetList">
      <el-table-column label="" width="55">
        <template slot-scope="{ row }">
          <el-radio v-model="targetingId" :label="row.caohuaTargetingId">&ensp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="caohuaTargetingId" label="ID" width="100"> </el-table-column>
      <el-table-column prop="targetingName" label="定向包名称"> </el-table-column>
    </el-table>
  </Modal>
</template>

<script setup>
import { ref } from 'vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({
  targetList: Array
})
const targetingId = ref('')
function onConfirm() {
  const targetItem = props.targetList.find((target) => target.caohuaTargetingId === targetingId.value)
  emits('confirm', targetItem)
  targetingId.value = ''
}
</script>

<style lang="scss" scoped>
</style>
